import { useMutation } from "@apollo/client";
import get from "lodash-es/get";

import useSnackbars from "hooks/useSnackbars";

import { normalizeGraphqlErrors } from "utils/normalizeGraphqlErrors";

export default function useExecuteMutation(
  mutationQuery,
  {
    refetchQueries = [],
    optionsQuery = {},
    onSuccessMessage = "",
    onSuccessCallback = () => {},
    fieldsWithPlaceForError = [],
  } = {},
) {
  const { errorSnackbar, warningSnackbar, notificationSnackbar } =
    useSnackbars();
  const [mutation, { loading }] = useMutation(mutationQuery, {
    refetchQueries,
    awaitRefetchQueries: true,
    ...optionsQuery,
  });

  const executeMutation = async (data) => {
    try {
      const response = await mutation({
        variables: data,
      });
      if (response.errors?.length) {
        const normalizedErrors = normalizeGraphqlErrors(
          response.errors,
          fieldsWithPlaceForError,
        );
        normalizedErrors.snackBarErrors.forEach((error) =>
          errorSnackbar(error),
        );
        return normalizedErrors;
      }
      onSuccessCallback();
      onSuccessMessage && notificationSnackbar(onSuccessMessage);
      for (const responseKey in response.data) {
        const message = get(response, `data.${responseKey}.message`);
        message && warningSnackbar(message);
      }
      return response.data;
    } catch (error) {
      const errorMessage = get(
        error,
        "networkError.result.errors[0].message",
        error.message,
      );
      errorSnackbar(errorMessage);
    }
  };

  return { executeMutation, loading };
}
